<div class="bg-light border-bottom cpt-16 cpb-12">
  <p class="text-center fw-6">{{ 'Formula editor' | translate }}</p>
</div>
<div #katextcontainer class="katex-container d-flex flex-column align-items-center cpx-16 flex-1">
  <div class="w-75 border-bottom katex-value" style="height: 70px">
    <ng-katex
      [equation]="katex"
      [options]="{ throwOnError: false, displayMode: true }"
      #katexRenderer
    ></ng-katex>
  </div>
  <div class="buttons d-flex justify-content-center w-75 cmt-12 cmb-24">
    <button
      *ngIf="!isMobile"
      mat-button
      class="latex-btn"
      [class.selected]="mode === Modes.Write"
      (click)="activateWriteMode()"
      data-name="math-tool-option-keyboard"
    >
      <i class="material-icons">keyboard</i>
      {{ 'Keyboard' | translate }}
    </button>
    <button
      mat-button
      class="latex-btn"
      [class.selected]="mode === Modes.Paste"
      (click)="activatePasteMode()"
      data-name="math-tool-option-latex"
    >
      <i class="material-icons">code</i>
      {{ 'LaTeX' | translate }}
    </button>
    <button
      mat-button
      class="latex-btn"
      [class.selected]="mode === Modes.Magic"
      (click)="activeMagicMode()"
      data-name="math-tool-option-magic"
    >
      <i class="material-icons">auto_fix_high</i>
      {{ 'Magic' | translate }}
    </button>
  </div>
  <div class="flex-1 position-relative h-100 drawing-container" [class.error]="isKatexError">
    <p class="placeholder cmb-4" *ngIf="mode === Modes.Write && !katex">
      {{ 'Type your equation...' | translate }}
    </p>
    <ng-container *ngIf="mode === Modes.Magic">
      <p class="placeholder cmb-4" *ngIf="!katex">
        {{ 'Draw math equations and watch the magic happen...' | translate }}
      </p>
      <p class="placeholder myscript-sign" *ngIf="isConverting">
        {{ 'Converting to LaTeX...' | translate }}
      </p>
    </ng-container>

    <div
      id="math-field"
      class="w-100"
      [style.visibility]="mode === Modes.Write ? 'visible' : 'hidden'"
    >
      {{ katex }}
    </div>
    <div
      id="magic-editor"
      [style.visibility]="mode === Modes.Magic ? 'visible' : 'hidden'"
      class="magic-canvas-container"
    >
      <canvas #magicCanvas id="magic-canvas"></canvas>
    </div>
    <textarea
      *ngIf="mode === Modes.Paste"
      [placeholder]="'Type your Latex code ...' | translate"
      [(ngModel)]="katex"
      (keyup)="escapeLatexDelimeter()"
      (change)="updateMathField()"
    ></textarea>

    <!-- Magic Mode Controls -->
    <button
      class="btn-clean"
      [class.disabled]="!canMagicClear()"
      [disabled]="!canMagicClear()"
      (click)="magicClear()"
      *ngIf="mode === Modes.Magic"
      data-name="math-tool-option-magic-clear"
    >
      {{ 'Clear' | translate }}
    </button>
  </div>
</div>

<div class="d-flex justify-content-end cp-16 footer-buttons">
  <button
    class="btn btn-light cmr-sm-16 cmx-0 cmt-16 cmt-sm-0 fw-6 d-flex align-items-center"
    (click)="cancelClick()"
    data-name="math-tool-close"
  >
    <i class="material-icons cmr-8 font-18">close</i> {{ 'Cancel' | translate }}
  </button>
  <button
    class="btn btn-primary fw-6 d-flex align-items-center text-white"
    [disabled]="!katex"
    (click)="doneClick()"
    cdkFocusInitial
    data-name="math-tool-done"
  >
    <i class="material-icons cmr-8 font-18">done</i>
    {{ 'Done' | translate }}
  </button>
</div>
